import { render, staticRenderFns } from "./PaymentPlanDetailPage.vue?vue&type=template&id=2af42434&"
import script from "./PaymentPlanDetailPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentPlanDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports